import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleSupport } from '../../../redux/main/main.actions';

import { selectIsCanvasModalPricingPlanLimitMaxEnabled, selectCanvasModalPricingPlanLimitMaxType } from '../../../redux/diagram/diagram.selectors';
import { disableCanvasPricingPlanLimitMax } from '../../../redux/diagram/diagram.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalPricingPlanLimitMaxCanvas.scss';

const mapTypesAmounts = {
    diagrams: 100,
    tables: 400,
    columns: 80,
    notes: 200,
    pens: 400,
    areas: 200,
}
const mapTypesValues = {
    diagrams: 'diagrams',
    tables: 'tables',
    columns: 'columns / table',
    notes: 'notes',
    pens: 'draws',
    areas: 'areas',
}

export const ModalPricingPlanLimitMaxCanvas = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsCanvasModalPricingPlanLimitMaxEnabled);
    const modalType = useSelector(selectCanvasModalPricingPlanLimitMaxType);

    const [type, setType] = useState('');

    useEffect(() => {
        if (!modalType) return;
        setType(modalType);
        return () => { };
    }, [modalType]);

    const handleSave = () => {
        trackEvent('app_modal_pricing_limit_max_submit', {
            page: 'app',
            type: 'modals',
            subtype: type,
        });
        dispatch(disableCanvasPricingPlanLimitMax(null));
        dispatch(toggleSupport('feedback', 'canvas'));
        setTimeout(() => {
            setType('');
        }, 300);
    };

    const handleCancel = () => {
        dispatch(disableCanvasPricingPlanLimitMax(null));
        setTimeout(() => {
            setType('');
        }, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-pricing-limit-max-canvas ${type}`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{`You're growing fast! 🚀`}</div>
            <div className="modal-content-body">
                <div className='description-text'>
                    {/* You’ve hit the cap for free diagrams.< br /> */}
                    You’ve reached the current limit of {mapTypesAmounts[type]} {mapTypesValues[type]}.< br />
                    Contact us to share your use case and table needs.
                </div>
                <button onClick={() => handleSave()}>Contact Us</button>
            </div>
        </Modal>
    );
};

export default ModalPricingPlanLimitMaxCanvas;
